import { render, staticRenderFns } from "./Together.vue?vue&type=template&id=6c0edfe2&scoped=true&"
import script from "./Together.vue?vue&type=script&lang=js&"
export * from "./Together.vue?vue&type=script&lang=js&"
import style0 from "./Together.vue?vue&type=style&index=0&id=6c0edfe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0edfe2",
  null
  
)

export default component.exports